import invariant from 'invariant'

import { LegacyHint, useStyles, Popover } from '@signavio/ui'

import { Disable, ThemeT, utils } from '@signavio/effektif-commons'
import { ReactNode } from 'react'

type SneakPeekProps = {
  hint?: string
  tooltipPlacement?: PositionT
  children: ReactNode
  tooltip?: ReactNode
}

function SneakPeek({
  hint,
  children,
  tooltipPlacement,
  tooltip,
}: SneakPeekProps) {
  const style = useStyles(defaultStyle, {})

  if (tooltip) {
    return (
      <Popover position={tooltipPlacement || 'top'} popover={tooltip}>
        <div {...style('feature')}>
          <Disable>{children}</Disable>
        </div>
      </Popover>
    )
  }

  if (hint) {
    return (
      <div {...style}>
        <div {...style('feature')}>
          <Disable>{children}</Disable>
        </div>

        <div {...style('hintContainer')}>
          <div {...style('hint')}>
            <LegacyHint info inline>
              {hint}
            </LegacyHint>
          </div>
        </div>
      </div>
    )
  }

  invariant(
    false,
    'The SneakPeek component needs either a tooltip or a hint. None was provided.'
  )
}

const defaultStyle = ({ color, padding }: ThemeT) => ({
  position: 'relative',

  hint: {
    display: 'inline-block',

    textAlign: 'center',

    paddingTop: padding.normal,
    paddingLeft: padding.normal,
    paddingRight: padding.normal,
    paddingBottom: padding.large,

    backgroundColor: 'white',

    ...utils.transition('opacity'),
    ...utils.popover(color),
  },

  hintContainer: {
    position: 'absolute',
    width: '100%',
    textAlign: 'center',
    top: '50%',
    transform: 'translateY(-50%)',
  },

  feature: {
    ...utils.grayscale(),
  },
})

export default SneakPeek
